module.exports = __webpack_public_path__ + "assets/90RotationCCW.22de27f3753e6d7c7571891b0ed2c19e.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/90RotationCCW.gmt
// module id = 883
// module chunks = 0